module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "card "
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', [_c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.id),
      expression: "model.id"
    }],
    attrs: {
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Id")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.id),
      expression: "model.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.id = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.has('nome')
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nome')),
      expression: "errors.has('nome')"
    }],
    staticClass: "form-control-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.has('bpmnId')
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Identificador do workflow")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.model.bpmnId),
      expression: "model.bpmnId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "bpmnId"
    },
    domProps: {
      "value": (_vm.model.bpmnId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.bpmnId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bpmnId')),
      expression: "errors.has('bpmnId')"
    }],
    staticClass: "form-control-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('bpmnId')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-sm",
    attrs: {
      "to": '/beast/workflows'
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" "), _c('strong', [_vm._v("Workflow")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2293148a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2293148a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/beast/workflows/Form.vue
// module id = 1559
// module chunks = 1